import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { LinksSections } from './../constans/links-sections';
@Injectable()
export class RedirectService {

    submit = new Subject<boolean>();

    constructor(
        private router: Router,
        private _authService: AuthService) { }

    observerSubmit() {
        return this.submit.asObservable();
    }

    post(obj, url) {
        this.submit.next(true);
        const mapForm = document.createElement('form');
        mapForm.target = 'reportView';
        mapForm.method = 'POST';
        mapForm.action = url;
        Object.keys(obj).forEach(function (param) {
            const mapInput = document.createElement('input');
            mapInput.type = 'hidden';
            mapInput.name = param;
            mapInput.setAttribute('value', obj[param] === null ? '' : obj[param]);
            mapForm.appendChild(mapInput);
        });
        document.body.appendChild(mapForm);
        mapForm.submit();
        setTimeout(() => {
            document.body.removeChild(mapForm);
        }, 500);
    }

    redirectConectividad(moduloConectividad, section, datos?: any): void {
        this._authService.setCurrentModule(moduloConectividad);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(5);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }

    }

    redirectionTaller(moduloTaller, section, datos?: any): void {
        this._authService.setCurrentModule(moduloTaller);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(3);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }
    }
    redirectionAmacen(moduloAlmacen, section, datos?: any): void {
        this._authService.setCurrentModule(moduloAlmacen);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(2);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }
    }
    redirectionVO(moduloVO, section, datos?: any): void {
        this._authService.setCurrentModule(moduloVO);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(7);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }

    }

    redirectionFacturacion(moduloFacturas, section, datos?: any): void {
        this._authService.setCurrentModule(moduloFacturas);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(4);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }
    }


    redirectionContabilidad(moduloContabilidad, section, datos?: any): void {
        this._authService.setCurrentModule(moduloContabilidad);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(6);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }
    }

    redirectionGeneral(moduloGeneral, section, datos?: any): void {
        this._authService.setCurrentModule(moduloGeneral);
        const child = LinksSections[section];
        this._authService.setDataOptionMenu(child);
        this._authService.setModuloActivo(1);
        const auxRoute = child.route;
        if (datos) {
            this.router.navigate([auxRoute, datos]);
        } else {
            this.router.navigate([auxRoute]);
        }
    }




}
